import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard, ExternalLink, CheckCircle2, AlertCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { Card, Btn } from "@/components/ui-kit";

export function ConnectCard() {
  const { restaurant } = useAuth();
  const { t } = useT();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/restaurants/${restaurant.id}/connect`).then((r) => setSt(r.data)).catch(() => setSt({ connected: false, error: true })); }, [restaurant.id]);
  const onboard = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/restaurants/${restaurant.id}/connect/onboard`, { origin_url: window.location.origin }); window.location.href = data.url; }
    catch (ex) { toast.error(errMsg(ex)); setBusy(false); }
  };
  const ok = st?.charges_enabled;
  return (
    <Card data-testid="connect-card">
      <p className="flex items-center gap-2 font-heading font-bold"><CreditCard size={18} className="text-[#4a8a56]" />{t("pay_online_title")}</p>
      <p className="mt-1 text-sm text-slate-600">{t("pay_online_desc")}</p>
      {st && <div data-testid="connect-status" className={`mt-3 flex items-center gap-2 rounded-xl p-3 text-sm font-semibold ${ok ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`}>
        {ok ? <CheckCircle2 size={16} /> : <AlertCircle size={16} />}{ok ? t("connect_active") : st.connected ? t("connect_pending") : t("connect_missing")}
      </div>}
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <Btn data-testid="connect-onboard-btn" disabled={busy} onClick={onboard}><ExternalLink size={16} />{ok ? t("connect_manage") : st?.connected ? t("connect_continue") : t("connect_start")}</Btn>
        {st?.fee_pct > 0 && <span className="text-xs text-slate-500">{t("platform_fee")}: {st.fee_pct}%</span>}
      </div>
    </Card>
  );
}
